
// 查询条件缓存调度中心

export default class Cache {
    // 请求参数缓存静态常量
    static CACHE_QUERY = 'QUERY'
    // tab缓存静态常量
    static CACHE_TAB = 'TAB'
    // 分页缓存常量
    static CACHE_PAGES = 'PAGES'
    options = {}

    // 定义Cache配置默认参数 
    #DEFAULT_OPTIONS = {
        module: Cache.CACHE_QUERY // 缓存的类型， 目前是两种 ，查询参数和tab
    }

    /**
     * @description: 
     * @param {*} options => 缓存配置
     * @return {*}
     */    
    constructor(options) {
        if (options && !isObject(options)) {
            throw new Error('传入配置不是object类型')
        }
        this.options = this.margeOptions(options)
        
    }

    /**
     * @description: 设置缓存 
     * @param {key: 缓存键, val: 缓存值, type: 缓存模块类型}
     * @return {}
     */   
    setCache({key, params, type} = {}) {
        // 默认取当前路径为key设置缓存
        try {
            key = key || window.$Vue.$route.path
            if (!key) {
                throw new Error('key为空')
            }
            if (!isObject(params)) {
                throw new Error('params不是object类型')
            }
            
            // 当需要的缓存的值都不存在时， 不缓存
            if (params.query && JSON.stringify(params.query) !== '{}') {
                let vals = []
                vals = Object.values(params.query).filter(v => getValues(v)) || []
                if (!vals.length) {
                    params.query = {}
                    // this.removeCache({key})
                }
            }           
           
            const v = {
                key: this.getModuleBName(key, type),
                params
            }
            sessionStorage.setItem(v.key, JSON.stringify(v))
        } catch (error) {}
    }

    /**
     * @description: 获取缓存
     * @param {*} key
     * @return {object}
     */    
    getCache({key, type} = {}) {
        try {
            key = key || window.$Vue.$route.path
            const instance = sessionStorage.getItem(this.getModuleBName(key, type))
            if (!instance) return {}
            return JSON.parse(instance).params
        } catch (error) {}
    }

    // 移除Cache
    removeCache({key} = {}) {
        key = key || window.$Vue.$route.path
        sessionStorage.removeItem(this.getModuleBName(key))
    }
    // /**
    //  * @description: 更新缓存
    //  * @param {key: 要更新的key, options：需要更新的数据对象，以键值对的形式传来} 
    //  */
    // updateCache(key = '', options = {}) {
    //     key = key || window.$Vue.$route.path
    //     // 先获取该key缓存， 判断是否有无
    //     const instance = this.getCache({ key })
    //     // 如果不存在， 无需更新
    //     if (!instance || JSON.stringify(instance) === '{}') return
    //     console.log()
    // }
    //清除所有缓存
    static deleteCache() {
        sessionStorage.clear();
    }

    // 合并Cache配置参数
    margeOptions(opt) {
        opt = opt || {}
        return Object.assign(this.#DEFAULT_OPTIONS, opt, {})
    }

    // 得到设置缓存的模块名， Tab || query || pages
    getModuleBName(key, type) {
        if (!key) {
            console.error('key不能为空')
        }
        return `${type || this.options.module}-${key}`
    }
}


// 判断是否为对象
const isObject = val => Object.prototype.toString.call(val).slice(8, -1) === 'Object'

function getValues(vals) {
    if (isObject(vals)) return getValuesLen(vals)
    return !!vals
}

function getValuesLen(info = {}) {
    if (JSON.stringify(info) === '{}') return false
    let s = Object.values(info).filter(v => v) || []
    s = s.flat()
    return !!s.length
}

